export default __webpack_public_path__ + "static/media/welcome.29484c0b.jpeg";